// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";
//import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB84k9xpOE2jRhawECzTPCRqE_r5PMfwiY",
  authDomain: "mon-formulaire.firebaseapp.com",
  databaseURL: "https://mon-formulaire.firebaseio.com",
  projectId: "mon-formulaire",
  storageBucket: "mon-formulaire.appspot.com",
  messagingSenderId: "382213897114",
  appId: "1:382213897114:web:646e601e61b9ae59e61823",
  measurementId: "G-0X5BJE1HE8"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
const db = firebase.firestore();

firebase
  .auth()
  .signInAnonymously()
  .catch(function (error) {
    console.log(error);
  });

firebase
  .auth()
  .onAuthStateChanged(function (user) {
    if (user) {
      var isAnonymous = user.isAnonymous;
      var uid = user.uid;
      //console.log({ isAnonymous, uid });
    } else {
      console.log('user is sign');
    }
});

export { firebase, db }

